import { Inputs, FlexContainer } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { INSTALLMENTS_HELP_URL } from 'Constants/helpsUrl';
import { openLinkInNewTab } from 'Utils/links';
import { InstallmentsListProps } from './types';
import { transformInstallmentToOptions } from './utils';

const InstallmentsList = ({ data, setInstallments }: InstallmentsListProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const options = transformInstallmentToOptions(data);

  const handleClick = (option): void => {
    const share = options.findIndex(item => item.value === option) + 1;
    setInstallments(share);
  };
  const props = { defaultValue: options[0] };
  return (
    <FlexContainer direction="column">
      <Inputs.Select
        options={options}
        onChange={handleClick}
        label={t('Filing.toPay.installments')}
        helpButtonUrl={INSTALLMENTS_HELP_URL}
        onHelpButton={url => openLinkInNewTab(url)}
        {...props}
      />
    </FlexContainer>
  );
};

export default InstallmentsList;
